module.exports = __webpack_public_path__ + "images/royal-canin.sprite--iconography.e32be7ce6978855bcbb07c14cdc6b793.svg";